{
  "sf_user_permission_checker": {
    "filters_title": "FILTERS",
    "search_placeholder": "Search...",
    "header": "Tuvis Permission Checker",
    "cols": {
      "name": "Component Name",
      "label": "Component Label",
      "parent": "Parent Object",
      "type": "Type",
      "viewPermission": "View Permission",
      "writePermission": "Write Permission"
    },
    "permission": {
      "allow": "Allow",
      "denied": "Denied",
      "unknown": "Unknown",
      "none": "None"
    },
    "type": {
      "class": "Apex Class",
      "field": "Custom Field",
      "object": "Custom Object",
      "visualforce_page": "Visualforce Page"
    }
  },
  "new_word": "New",
  "crm_settings": {
    "country_code": "Country code",
    "users_deactivation": "Users deactivation",
    "auto_sync": "Auto sync",
    "notifications": "Notifications"
  },
  "chat_component": {
    "message_history": "Message History",
    "date_cannot_be_older_than_x_months": "Date cannot be older than {{months}} months",
    "date_range_cannot_be_longer_than_x_days": "Date range cannot be longer than {{days}} days",
    "select_all": "Select All",
    "deselect_all": "Deselect All",
    "export_pdf": "Export PDF",
    "export_csv": "Export CSV",
    "edited": "Edited",
    "deleted": "Deleted",
    "loading": "Loading",
    "synced_messages": "Synced messages",
    "by_tuvis": "by Tuvis",
    "no_message_1": "There are no messages yet",
    "no_message_2": "Turn on the auto sync option in the Tuvis Agent Panel to start syncing chats",
    "selected": "selected",
    "delete_messages": "Delete messages",
    "download_messages": "Download",
    "synced_by": "Synced by",
    "sent_by": "Sent by",
    "received_by": "Received by",
    "filters_title": "FILTER SYNCED MESSAGES",
    "search_input_placeholder": "Search messages",
    "search_group_placeholder": "Search group",
    "search_matches": "{{currentIndex}} out of {{numOfMatches}} matches",
    "today": "Today",
    "yesterday": "Yesterday",
    "groups": "Groups",
    "personal": "Personal",
    "no_link": "No groups currently linked",
    "premium_feature_header": "🔓 Unlock Premium Feature",
    "premium_feature_text": "Upgrade to access our premium feature and take your experience to the next level.",
    "premium_feature_contact_sales": "Contact sales",
    "voice_message": "Voice message",
    "last_months": "Last {{months}} months",
    "messages_created_date": "Messages created date",
    "by_last_months": "By last months",
    "by_date_range": "By date range",
    "date_cannot_be_in_future": "Date cannot be in the future",
    "from_date_cannot_be_bigger_then_to_date": "From date cannot be after to date",
    "to_date_cannot_be_smaller_then_from_date": "To date cannot be before from date",
    "from": "From",
    "to": "To",
    "apply": "Apply",
    "contact": {
      "name_one": "{{contactName}}",
      "name_other": "{{contactName}} and {{numberOfContacts}} others",
      "footer_one": "Message",
      "footer_other": "View all",
      "modal_header_one": "View Contact",
      "modal_header_other": "{{count}} Contacts",
      "birthday": "Birthday"
    },
    "you": "You",
    "customer": "Customer",
    "click_to_remove": "Click to remove",
    "forwarded": "Forwarded",
    "broadcast_list": "Broadcast list",
    "location": "Location",
    "disappearing_message": "Disappearing message",
    "pinned_message": "The message you opened this conversation from"
  },
  "chat_groups": {
    "title": "Chat Groups",
    "group_name": "Group name",
    "participants": "Participants",
    "number_of_messages": "Number of messages",
    "last_message": "Last message",
    "search_groups": "Search groups",
    "no_groups_to_show": "There are no groups to show",
    "no_results_found": "No results found",
    "try_different_keywords": "Try different keywords or make sure",
    "spelled_correctly": "everything is spelled correctly.",
    "back_to_groups_chats": "Back to Groups Chats",
    "number_of_participants": "{{numberOfMembers}} participants",
    "entity_unknown": "Unknown",
    "entity_contact": "Contact",
    "entity_lead": "Lead",
    "entity_blacklisted": "Blocklisted",
    "entity_blocked": "Blocked",
    "User": "User",
    "entity_sf_user": "Salesforce User",
    "entity_sf_manager": "Salesforce Manager",
    "entity_account": "Account",
    "search_matches": "{{currentIndex}} out of {{numOfMatches}} matches",
    "no_records_found": "No records found",
    "open_group_panel_to_link": "Open the group panel to link contacts",
    "search_message": "Search message",
    "selected": "Selected",
    "delete_messages": "Delete messages",
    "premium_feature_header": "Premium Feature",
    "message_only_for_upgraded_users": "This option is available only for premium users",
    "filters": {
      "created_by_me": "Created by me",
      "groups_im_in": "Groups I am in",
      "no_groups_to_show": "There are no groups to show with the current filter conditions"
    }
  },
  "entity_sf_user": "User",
  "error_try_again": "Please try again later",
  "search_person": {
    "loading": "Loading..."
  },
  "entity_filter": {
    "me": "Me",
    "clear_all": "Clear all",
    "reset_filter": "Reset filter"
  },
  "admin_only": "This page is only for Tuvis Admin!",
  "admin_or_sys_admin_only": "This page is only for Tuvis Admin or System Admin!",
  "missing_template_tuvis_custom_permission": "You don't have access to this page. Please contact your Salesforce Administrator. Required custom permission: Tuvis_Allow_Access_To_Templates_Tab",
  "user_management": {
    "headers": {
      "user_details": "User Details",
      "configurations": "Configurations"
    },
    "delete_pending_user_modal": {
      "line1": "Are you sure you want to remove <{{email}}>?",
      "line2": "They will not have access to Tuvis.",
      "title": "Are you sure?"
    },
    "disable_user_modal": {
      "line1": "This will immediately revoke the access for this user.",
      "line2": "Are you sure about it?",
      "title": "Disable user",
      "okText": "Disable user"
    },
    "user_layout_modal": {
      "title": "User layout"
    },
    "invite_user_modal": {
      "username": "Username",
      "primary_user_must_manage_users": "Primary user must have permission to manage other users",
      "inherited_from_group_one": "Inherited from group {{groupNames}}",
      "inherited_from_group_other": "Inherited from groups {{groupNames}}",
      "subtitle": "Admin details",
      "title": "Invite teammates to Tuvis",
      "new_org": "New organization",
      "org_name": "Organization name",
      "okText": "Invite ({{emailsToInviteCount}})",
      "user_update_success": "User was successfully updated",
      "user_update_failure": "User failed to update",
      "email": "Email",
      "first_name": "First Name",
      "last_name": "Last Name",
      "notify_inviter_on_sidecar_events": "Notify me about Remote Sync connections",
      "permissions": {
        "title": "Permissions",
        "update_success": "Permissions were successfully updated",
        "update_failure": "Permissions failed to update",
        "show_analytics_ui": "Access Engagement insights",
        "show_dashboards_ui": "Access Dashboards",
        "analytics_compliance": "Access Compliance",
        "show_chat_groups_ui": "Access Chat Groups",
        "sidecars_enabled": "Access Remote Sync UI",
        "allow_inviting_users": "Access Users Management UI",
        "allow_desktop_lite": "Access to Tuvis desktop lite",
        "allow_platform_integrations": "Access to Integrations UI",
        "allow_platform_admin_notifications": "Access to Notifications UI",
        "allow_platform_global_layout": "Access to Global layout UI",
        "access_audit_log": "Access to Audit log UI",
        "show_saml_settings": "Access SSO settings"
      },
      "granular_permissions": {
        "sidecars_enabled": "Tuvis Remote Sync",
        "sidecars": {
          "view": "View",
          "create": "Create",
          "invite": "Invite",
          "update": "Update",
          "delete": "Delete",
          "view_messages": "View messages",
          "all": "All",
          "notifications": "Notifications"
        },
        "allow_messages_analytics": "Messages Analytics",
        "messages_analytics": {
          "view": "View",
          "export": "Export",
          "all": "All"
        },
        "allow_platform_integrations": "Integrations",
        "destinations": {
          "view": "View",
          "update": "Update",
          "delete": "Delete",
          "all": "All"
        },
        "show_saml_settings": "SSO settings",
        "saml": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "access_audit_log": "Audit log",
        "audit_log": {
          "view": "View"
        },
        "allow_platform_global_layout": "Global layout",
        "global_layout": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "allow_platform_admin_notifications": "System notifications",
        "notifications": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "allow_desktop_lite": "Tuvis Desktop lite",
        "allow_mobile_call_recording": "Allow mobile call recordings",
        "allow_inviting_users": "Users Management",
        "user_management": {
          "view": "View",
          "invite": "Invite",
          "activate": "Activate",
          "update_permissions": "Update permissions",
          "view_groups": "View groups",
          "update_groups": "Update groups",
          "assign_groups": "Assign User groups",
          "edit_user": "Edit user",
          "view_messages": "View Messages",
          "merge": "Merge users",
          "all": "All"
        },
        "show_chat_groups_ui": "Chat Groups",
        "chat_groups": {
          "view": "View"
        },
        "show_im_groups_ui": "IM Groups",
        "im_groups": {
          "view": "View"
        },
        "show_analytics_ui": "Engagement Dashboard",
        "analytics": {
          "view": "View",
          "view_messages": "View Messages"
        },
        "show_dashboards_ui": "Dashboards",
        "show_custom_filters_ui": "Custom Filters",
        "dashboards": {
          "view": "View",
          "update": "Update",
          "create": "Create",
          "all": "All"
        },
        "custom_filters": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "analytics_compliance": "Compliance",
        "compliance": {
          "view": "View"
        },
        "allow_incidents": "Incidents",
        "incident": {
          "view": "View Incidents",
          "update": "Update Incidents"
        },
        "allow_dlp": "Data Loss Protection",
        "enable_surveillance": "Surveillance",
        "surveillance": {
          "view": "View Policies",
          "update": "Update Policies",
          "view_incidents": "View Incidents",
          "view_analytics": "View Analytics",
          "update_incidents": "Update Incidents",
          "all": "All"
        },
        "dlp": {
          "view": "View Policies",
          "update": "Update Policies",
          "view_analytics": "View Analytics",
          "all": "All"
        },
        "allow_waba": "WhatsApp Business API",
        "waba": {
          "view_settings": "View settings",
          "update_settings": "Update settings",
          "agent": "Agent",
          "all": "All"
        },
        "allow_twilio": "Tuvis Call Recording",
        "twilio": {
          "view_settings": "View settings",
          "update_settings": "Update settings",
          "agent": "Agent",
          "all": "All"
        },
        "allow_customer_facing_settings": "Settings",
        "settings": {
          "view_general": "View settings",
          "update_general": "Update settings",
          "all": "All"
        },
        "allow_public_api": "Public API",
        "api_keys": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "allow_url_policy": "Url Policy",
        "url_policy": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "allow_keyword_insights": "Keyword Insights",
        "keyword_insights": {
          "view": "View",
          "update": "Update",
          "view_analytics": "View Analytics",
          "all": "All"
        },
        "allow_phones_blocklist": "Private Phone Numbers",
        "phones_blocklist": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "allow_blocked_phones": "Block Phones (chat)",
        "blocked_phones": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "allow_phones_whitelist": "Allowed Phones List",
        "phones_whitelist": {
          "view": "View",
          "update": "Update",
          "all": "All"
        },
        "allow_tuvis_contacts": "Tuvis Contacts",
        "tuvis_contacts": {
          "view": "View",
          "update": "Update",
          "create": "Create",
          "all": "All"
        },
        "allow_slack_platform": "Slack Platform",
        "slack": {
          "view_settings": "View settings",
          "update_settings": "Update settings",
          "all": "All"
        },
        "allow_teams_platform": "Teams Platform",
        "teams": {
          "view_settings": "View settings",
          "update_settings": "Update settings",
          "all": "All"
        },
        "allow_bot_builder": "Bot Builder",
        "allow_elite_token": "Elite Security Token",
        "elite_token": {
          "all": "All",
          "view": "View",
          "update": "Generate"
        },
        "bot_builder": {
          "view_analytics": "View Analytics",
          "view": "View",
          "update": "Update",
          "view_triggers": "View Triggers",
          "trigger_flows": "Trigger Flows",
          "all": "All"
        },
        "fraud_detection": "Fraud Detection",
        "phishing_fraud_detection": "Phishing Detection",
        "fraud": {
          "view": "View",
          "update": "Update",
          "view_incidents": "View Incidents",
          "view_urls": "View URLs",
          "update_urls": "Update URLs",
          "update_incidents": "Update Incidents",
          "all": "All"
        },
        "allow_archive": "Archive",
        "archive": {
          "view_settings": "View settings",
          "update_settings": "Update settings",
          "all": "All"
        },
        "allow_im_templates": "IM Templates",
        "allow_secure_storage": "Secure Storage",
        "secure_storage_retention_days": "Secure Storage retention (days)",
        "secure_storage_allow_user_delete": "Users can delete their Secure Storage files",
        "im_templates": {
          "all": "All",
          "view": "View",
          "create": "Create",
          "update": "Update",
          "delete": "Delete"
        }
      }
    },
    "no_users_to_show": "There are no users to show",
    "no_pending_users_to_show": "There aren’t any pending members",
    "title": "Users Management",
    "purchased_licenses": "{{numOfSeats}} Purchased Licenses",
    "consumed_licenses": "{{numOfUsedSeats}} Consumed Licenses",
    "users_count": "{{activeSeats}} Users",
    "download_csv": "Download CSV",
    "invite_users": "Invite Users",
    "drop_csv": "Drop CSV file here or click to browse",
    "csv_errors": {
      "empty_file": "CSV file is empty",
      "missing_required_headers": "CSV file missing required headers: {{missingRequiredHeaders}}",
      "invalid_headers": "CSV file contain invalid headers: {{invalidHeaders}}",
      "invalid_emails": "CSV file contain rows with invalid emails: {{invalidEmails}}",
      "invalid_phones": "CSV file contain rows with invalid phones: {{invalidPhones}}",
      "missing_first_name": "CSV file contain rows with missing first name: {{missingFirstName}}",
      "missing_last_name": "CSV file contain rows with missing last name: {{missingLastName}}"
    },
    "import_users_preview": "Preview",
    "import_users_csv_button": "Import CSV",
    "import_users_csv_template": "Download CSV Template",
    "required": "required",
    "import_button": "Import",
    "update_existing_users": "Update existing users",
    "import_users_modal_text": "Create a CSV File: Ensure your CSV file includes the following columns:",
    "import_users_csv_invalid_format": "Invalid CSV format: {{header}}",
    "import_users_csv_success": "Import results: {{numOfNewUsers}} new users added from the CSV file, {{numOfExistingUsers}} users skipped due to existing records.",
    "import_users_csv_success_update": "Import results: {{numOfNewUsers}} new users added, {{numOfUpdatedUsers}} existing users updated.",
    "import_users_csv_failure": "Users failed to import {{error}}",
    "invite_users_failure": "Users failed to invite {{error}}",
    "search_users_placeholder": "Search Teammates",
    "search_pending_users_placeholder": "Search pending members",
    "change_sidecars_settings_failure": "Failed to change device settings",
    "change_sidecars_settings_success": "Changed device settings successfully",
    "filters": {
      "title": "FILTER USERS",
      "hide_users": "Show only active (Tuvis)",
      "online_only": "Online only",
      "restrict_to_direct_reports": "Restrict to direct reports"
    },
    "tabs": {
      "users": "TEAMMATES",
      "pending": "PENDING MEMBERS"
    },
    "cols": {
      "avatar": "Avatar",
      "name": "Name",
      "username": "Username",
      "phone": "Phone",
      "platform": "Platform",
      "channels": "Channels",
      "roles": "Roles",
      "profile": "Profile",
      "created": "Created date",
      "last_login": "Last login",
      "last_login_platform": "Last login (Platform)",
      "last_login_desktop": "Last login (Desktop)",
      "last_login_extension": "Last login (Extension)",
      "last_login_mobile": "Last login (Mobile)",
      "active_sf": "Active (SF)",
      "active_tuvis": "Active (Tuvis)",
      "auto_sync_person": "Default Auto Sync Mode (Person)",
      "auto_sync_group": "Default Auto Sync Mode (Group)",
      "groups": "Groups",
      "userId": "User ID",
      "orgId": "Organization ID",
      "login_provider": "Login Provider",
      "login_provider_user_id": "Login Provider - User ID",
      "email": "Email",
      "manager": "Manager",
      "online": "Online",
      "online_tooltip": "Online in the past 5 minutes in {{source}}",
      "offline_tooltip": "Not active in the last 5 minutes in Tuvis Desktop App",
      "online_source": {
        "desktop": "Tuvis Desktop App",
        "extension": "Tuvis Extension",
        "unknown": "Unknown"
      }
    },
    "groups": {
      "remove_group": "Remove group {{name}}",
      "add_group": "Add group"
    },
    "pending_cols": {
      "email": "Email",
      "invite_date": "Invite date",
      "actions": "Actions"
    },
    "actions": {
      "delete": "Delete",
      "confirm_delete_title": "Are you sure?",
      "confirm_delete_text": "Deleting a user cannot be undone. Are you sure you want to delete this user?",
      "delete_success": "User was successfully deleted",
      "delete_failure": "User failed to delete",
      "update": "Update",
      "resend_invite": "Resend invite",
      "resend_success": "Invite was successfully resent",
      "resend_failure": "Invite failed to resend"
    },
    "platform": {
      "extension": "Extension",
      "desktop": "Desktop",
      "platform": "Platform"
    }
  },
  "country_codes": {
    "title": "Manage country codes",
    "manage_codes": "Manage codes",
    "test_tool": "Test tool",
    "test_tool_description": "Insert a phone number like you do in Salesforce to see the routing response",
    "phone_number": "Phone number",
    "test_now": "Test now",
    "invalid_phone": "input phone doesn't match mobile phone pattern",
    "copy_to_clipboard": "Copy to clipboard",
    "test_results_copied": "Test results copied to clipboard",
    "manage_codes_subtitle": "Select the country code you use most frequently.",
    "manage_codes_desctiption": "We update these settings every 24 hours. To update them now please log out and log back into the agent panel.",
    "search_countries": "Search countries",
    "save": "Save changes",
    "max_countries_recommendation": "It's recommended to include up to 5 county codes",
    "max_countries_warning": "You can only select up to 5 country codes",
    "saved_successfully": "Country code settings were successfully saved",
    "saved_failed": "Country code settings failed to save",
    "loading": "Loading"
  },
  "manageTemplates": {
    "seems_like_no_templates": "Seems like you don't have any templates yet",
    "time_to_create_a_new_one": ", but it’s the perfect time to create your first one.",
    "templates_library": "Templates Library",
    "search_templates": "Search templates",
    "template_name": "Template name",
    "status": "Status",
    "visibility": "Visibility",
    "message": "Message",
    "owner": "Owner",
    "created_date": "Created date",
    "last_modified": "Last modified",
    "no_templates_to_show": "There are no templates to show",
    "filters_title": "FILTER TEMPLATES",
    "filters_status": "Status",
    "filters_visibility": "Visibility",
    "filters_visibility_hidden": "Hidden",
    "filters_visibility_visible": "Visible",
    "delete_template_modal_part_1": "Are you sure you want to delete the",
    "delete_template_modal_part_2": "template?",
    "delete_template_modal_title": "Delete Template",
    "delete_template_modal_ok": "Delete",
    "selected_templates": "Templates",
    "delete_templates": "Delete templates",
    "delete_templates_modal_title": "Delete Templates",
    "delete_templates_modal_ok": "Delete",
    "delete_templates_modal_text": "Are you sure you want to delete {{count}} templates?",
    "activate_templates": "Activate templates",
    "activate_templates_modal_title": "Activate Templates",
    "activate_templates_modal_ok": "Activate",
    "activate_templates_modal_text": "Are you sure you want to activate {{count}} templates?",
    "stop_templates": "Stop templates",
    "stop_templates_modal_title": "Stop Templates",
    "stop_templates_modal_ok": "Stop",
    "stop_templates_modal_text": "Are you sure you want to stop {{count}} templates?"
  },
  "create_or_edit_templates": {
    "template_preview_placeholder": "Template message",
    "template_preview": "Template preview",
    "too_many_file_upload": "You can upload up to 4 files, if you would like to change files please delete selected file first",
    "failed_to_save": "Failed to save template",
    "template_must_have_name": "Template must have a name",
    "template_must_include_message": "Template must include a message",
    "save": "Save",
    "template": "TEMPLATE",
    "template_name": "Template Name",
    "settings": "SETTINGS",
    "status": "Status",
    "active": "Active",
    "stopped": "Stopped",
    "public": "Public",
    "editable": "Editable",
    "visibility_rules": "Visibility rules",
    "choose_users": "Choose which users can see and use this template.",
    "add_new_rule": "Add New Rule",
    "message": "Message",
    "insert_personalized_token": "Insert a personalized token",
    "visibility_rules_section": "VISABILITY RULES",
    "search_rule_name": "Search rule name",
    "search_personalized_token": "Search personalized token",
    "create_template": "Create Template",
    "edit_template": "Edit Template",
    "personalized_modal": {
      "title": "Set up default value for {{personalizedLabel}}",
      "done": "Done",
      "default_value": "Default value",
      "text_trans": {
        "header": "Transformations",
        "lowercase": "lowercase",
        "uppercase": "UPPERCASE",
        "capitalize": "Capitalize Each Word",
        "none": "None"
      }
    },
    "upload_images": {
      "upload_images": "Upload Files",
      "record_audio": "Record Voice Message",
      "recording_audio": "Recording Voice Message",
      "up_to_4_images": "Up to 4 files",
      "supported_files": "Supported files: jpg, png, gif, pdf, ogg, aac, amr",
      "recommended_max_size": "Maximum size: 3 MB.",
      "recording_cannot_have_text": "A recording cannot include text, template message will be ignored",
      "file_exceeds_size_limit": "File(s) exceeded the {{maxSize}} MB size limit and were not uploaded: {{fileNames}}"
    }
  },
  "common": {
    "open_salesforce": "Back to Salesforce",
    "crm_table": {
      "no_results_found": "No results found",
      "try_other_filters_combination": "Try other filters combination",
      "try_different_keywords": "Try different keywords or make sure",
      "spelled_correctly": "everything is spelled correctly.",
      "try_different_filters": "Try to use different filters"
    }
  },
  "autoSyncPage": {
    "header": "Auto sync",
    "modalTitle": "Delete Messages",
    "modalButton": "Delete",
    "desc": "Delete all synced messages history from all contacts. This action cannot be undone",
    "button": "Delete all messages",
    "confirmDeleteModalText": "This will delete all WhatsApp messages that were synced to Salesforce, including all statuses that each user made and any other settings\nrelated to auto-sync.\n",
    "confirmDeleteModalConfirm": "Are you sure about it?",
    "delete_all_placeholder": "Type 'DELETE ALL' to proceed",
    "delete_success": "All messages were successfully deleted",
    "delete_failure": "Operation failed. Please contact support",
    "loading": "Loading"
  },
  "usersDeactivationPage": {
    "never": "Never",
    "Every_1_hour": "Every 1 hour",
    "Every_6_hour": "Every 6 hour",
    "Every_6_hour_desc": "Runs every day at 12AM, 6AM, 12PM, 6PM",
    "Every_12_hour": "Every 12 hour",
    "Every_12_hour_desc": "Runs every day at 12AM, 12PM",
    "Every_24_hour": "Every 24 hour",
    "Every_24_hour_desc": "Runs every day at 12AM",
    "Every_2_days": "Every 2 days",
    "Every_2_days_desc": "Runs on Monday, Wednesday, Friday at 12AM",
    "Every_7_days": "Every 7 days",
    "Every_7_days_desc": "Runs every Sunday at 12AM",
    "header": "User deactivation",
    "runNow": "Run now",
    "saveSettings": "Save settings",
    "previousRun": "Previous run",
    "nextRun": "Next run",
    "modal_start_now": "Job run started successfully",
    "modal_finish_now": "Job finished successfully",
    "modal_saved_interval": "New job interval saved successfully",
    "desc": "Set an automated user deactivation interval:",
    "loading": "Loading"
  },
  "autoSyncActivitiesPage": {
    "never": "Never",
    "Every_1_hour": "Every 1 hour",
    "Every_6_hour": "Every 6 hour",
    "Every_6_hour_desc": "Runs every day at 12AM, 6AM, 12PM, 6PM",
    "Every_12_hour": "Every 12 hour",
    "Every_12_hour_desc": "Runs every day at 12AM, 12PM",
    "Every_24_hour": "Every 24 hour",
    "Every_24_hour_desc": "Runs every day at 12AM",
    "Every_2_days": "Every 2 days",
    "Every_2_days_desc": "Runs on Monday, Wednesday, Friday at 12AM",
    "Every_7_days": "Every 7 days",
    "Every_7_days_desc": "Runs every Sunday at 12AM",
    "runNow": "Run now",
    "saveSettings": "Save settings",
    "previousRun": "Previous run",
    "nextRun": "Next run",
    "modal_start_now": "Job run started successfully",
    "modal_finish_now": "Job finished successfully",
    "modal_saved_interval": "New job interval saved successfully",
    "loading": "Loading",
    "header": "Auto sync activities",
    "desc": "Set an automated activities creation interval:"
  },
  "autoSyncCasesPage": {
    "header": "Auto sync cases",
    "desc": "Set an automated cases creation interval:"
  },
  "tuvisSetup": {
    "welcome": "Welcome to Tuvis",
    "description": "Need help getting started or learning more our features?",
    "doc_link": "See our docs"
  },
  "adminNotifications": {
    "user_logged_out": "User logged out",
    "user_uninstall_extension": "User uninstall extension",
    "user_turned_auto_sync_off": "User turned auto sync off",
    "user_turned_auto_sync_on": "User turned auto sync on",
    "user_turned_group_auto_sync_on": "User turned group auto sync on",
    "user_turned_group_auto_sync_off": "User turned group auto sync off",
    "api_currently_disabled": "API currently disabled",
    "apex_rest_services_disabled": "APEX rest services disabled",
    "new_user_created": "New user created",
    "user_logged_in": "User logged in",
    "title": "Notifications",
    "saveSettings": "Save settings",
    "subHeader": "Notify me about...",
    "recipients": "Recipients:",
    "recipients_text": "Add by typing email address or searching by name (Use “,” to add multiple members)",
    "saved_successfully": "Notifications settings were successfully saved",
    "saved_failed": "Notifications settings failed to save"
  },
  "globalLayout": {
    "title": "Global layout",
    "failed_to_update_hide_edit_layout": "Failed To update \"Hide edit layout\" please try again later",
    "hide_edit_layout": "Hide edit layout",
    "reset_user_layout": "Reset all organization users layout",
    "reset_user_layout_confirm": "Are you sure you want to reset all organization users layout?",
    "reset_user_layout_success": "All organization users layout were successfully reset",
    "reset_user_layout_failure": "All organization users layout failed to reset",
    "copy_another_org_global_layout": "Copy another organization global layout",
    "yes": "Yes",
    "back": "Back",
    "select_organization_to_copy_global_layout_from": "Select organization to copy global layout from",
    "select": "Select",
    "validate_copy_global_layout_from_other_org": {
      "row_1": "Are you sure you want to copy global layout",
      "row_2": "From:",
      "row_3": "To:"
    }
  },
  "record_type_layout": {
    "select_record_type": "Select Record type",
    "record_type": "Record type",
    "edit": "Edit",
    "manage_record_types": "Manage record types",
    "edit_record_type": "Edit record type",
    "select_record_types_to_display": "Select record types to display under lead:",
    "make_default": "Make default",
    "default": "Default"
  },
  "entity_sf_manager": "Salesforce Manager",
  "entity_account": "Account",
  "entity_opps": "Opportunity",
  "entity_activity": "Activity",
  "entity_activity_label": "Activity",
  "entity_task": "Task",
  "entity_task_label": "Task",
  "entity_case": "Case",
  "entity_person": "Person",
  "entity_new_lead": "New Lead",
  "entity_new_contact": "New Contact",
  "entity_new_account": "New Account",
  "entity_new_activity": "New Activity",
  "entity_new_task": "New Task",
  "entity_new_case": "New Case",
  "entity_new_event": "New Event",
  "entity_unknown": "Unknown",
  "entity_contact": "Contact",
  "entity_lead": "Lead",
  "entity_person_account": "Person Account",
  "entity_person_account_label": "Person Account",
  "entity_new_person_account": "New Person Account",
  "opp_form_fields_modal": {
    "submit": "Save",
    "cancel": "Cancel",
    "title": "Close this opportunity"
  },
  "action_button_event": "Event",
  "clear_all": "Clear all",
  "helpers_form_layouts": "Form Layouts",
  "editLayouts": {
    "edit_global_layouts": "Edit global layouts",
    "editing_the_global_layout_affects_all_records": "Editing the global layout affects all records",
    "select_layout_type": "Select layout type",
    "display_record_layout": "DISPLAY RECORD LAYOUT",
    "select_up_to_display_fields": "Select up to {{numberOfFields}} display fields",
    "save_changes": "Save changes",
    "multiple_record_preview": "Multiple record preview",
    "search_field_name": "Search field name",
    "mandatory_field": "Mandatory field",
    "add_fields": "Add fields",
    "always_require_a_value": "Always require a value in this field in order to save a record",
    "you_can_only_select_up to_fields": "You can only select up to {{numberOfFields}} fields"
  },
  "helpers_add_new_field": "Add New Fields",
  "tuvis_messaging_app": {
    "template_sent": "Your client has been notified (using {{templateName}}) and will receive your message as soon as they accept the conversation invitation. We're waiting on their response to continue the dialogue."
  },
  "incidents_summary_email": {
    "title": "Incident summary email",
    "saved_successfully": "Incident summary email settings were successfully saved",
    "saved_failed": "Incident summary email failed to save",
    "loading": "Loading...",
    "sub_header": "Allow sending incident summary to selected emails",
    "allow_incidents_summary_email": "Allow Incident Summary Email",
    "recipients": "Recipients:",
    "recipients_text": "Add by typing email address or searching by name (Use “,” to add multiple members)",
    "saveSettings": "Save settings"
  }
}
